<div id="setAffiliateDialog" 
    appDraggable dragTarget="#setAffiliateDialog" dragHandle="#setAffiliateDialogHeader"
    class="modal fade in ui-draggable ui-draggable-handle"
    role="dialog"
    tabindex="-1"
    >

    <div role="document" id="setAffiliateDialogContent">
        <div class="modal-content modal-dialog">

            <div class="modal-header" id="setAffiliateDialogHeader">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()" [disabled]="uiDisabled">
                    <span aria-hidden="true">x</span>
                </button>
                <h4 class="modal-title">
                    <span>Set MMC Affiliate</span>
                </h4>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                        MMC Affiliate
                    </div>
                    <div class="col-sm-8">
                        <select class="form-control" [(ngModel)]="selectedAffiliate">
                            <option [ngValue]="null"> -- None -- </option>
                            <option *ngFor="let affiliate of possibleAffiliates" [ngValue]="affiliate">
                                {{ affiliate }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="hide()" [disabled]="uiDisabled">
                    <i class="fa fa-ban"></i> CANCEL
                </button>
                <button type="button" class="btn btn-primary" (click)="update()" [disabled]="uiDisabled">
                    <i class="fa fa-refresh"></i> UPDATE
                </button>
            </div>

        </div>
    </div>

</div>